import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Header, LayoutContainer, themeCG, theme52, themeCB, themeCS, themeLH, themeOG, themeBB, themeYH, themeEV } from "@dp/xcomp";
import i18next from "i18next";
import { NativeBaseProvider } from "native-base";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
var GlobalMessageBanner = /*#__PURE__*/React.lazy(function () {
  return import("@dp/xcomp").then(function (module) {
    return {
      "default": module.GlobalMessageBanner
    };
  });
});
var LoginPopup = /*#__PURE__*/React.lazy(function () {
  return import("@dp/xcomp").then(function (module) {
    return {
      "default": module.LoginPopup
    };
  });
});
var SuccessDialog = /*#__PURE__*/React.lazy(function () {
  return import("@dp/xcomp").then(function (module) {
    return {
      "default": module.SuccessDialog
    };
  });
});
var ErrorDialog = /*#__PURE__*/React.lazy(function () {
  return import("@dp/xcomp").then(function (module) {
    return {
      "default": module.ErrorDialog
    };
  });
});
var MinimalHeader = /*#__PURE__*/React.lazy(function () {
  return import("@dp/xcomp").then(function (module) {
    return {
      "default": module.MinimalHeader
    };
  });
});

var loadTheme = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(brand) {
    var theme;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            console.log("brand == " + brand);
            theme = themeOG;
            _context.t0 = brand;
            _context.next = _context.t0 === "OG" ? 5 : _context.t0 === "OGC" ? 7 : _context.t0 === "LH" ? 8 : _context.t0 === "CS" ? 10 : _context.t0 === "BB" ? 12 : _context.t0 === "YH" ? 14 : _context.t0 === "S52" ? 16 : _context.t0 === "EV" ? 18 : _context.t0 === "CG" ? 20 : _context.t0 === "CB" ? 22 : 24;
            break;

          case 5:
            theme = themeOG;
            return _context.abrupt("break", 25);

          case 7:
            return _context.abrupt("break", 25);

          case 8:
            theme = themeLH;
            return _context.abrupt("break", 25);

          case 10:
            theme = themeCS;
            return _context.abrupt("break", 25);

          case 12:
            theme = themeBB;
            return _context.abrupt("break", 25);

          case 14:
            theme = themeYH;
            return _context.abrupt("break", 25);

          case 16:
            theme = theme52;
            return _context.abrupt("break", 25);

          case 18:
            theme = themeEV;
            return _context.abrupt("break", 25);

          case 20:
            theme = themeCG;
            return _context.abrupt("break", 25);

          case 22:
            theme = themeCB;
            return _context.abrupt("break", 25);

          case 24:
            theme = themeOG;

          case 25:
            return _context.abrupt("return", theme);

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function loadTheme(_x) {
    return _ref.apply(this, arguments);
  };
}();

var NativeBaseLayout = function NativeBaseLayout(props) {
  var _router$query;

  var _useState = useState(null),
      theme = _useState[0],
      setTheme = _useState[1];

  useEffect(function () {
    var _props$brand;

    loadTheme((_props$brand = props.brand) === null || _props$brand === void 0 ? void 0 : _props$brand.toUpperCase()).then(function (theme) {
      setTheme(theme);
    });
  }, [props.brand]);
  var router = useRouter();
  var opnSldr = (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.opnSldr;
  var links = [{
    text: "MENU",
    link: "/menu"
  }, {
    text: "ORDER NOW",
    link: "/order-online"
  }, {
    text: "JOIN WAITLIST",
    link: i18next.t("link.joinwaitlist.desktop", {
      defaultValue: "/home?waitlist=true"
    })
  }, {
    text: "CAREERS",
    link: "https://jobs.olivegarden.com/"
  }];
  var layoutProps = props === null || props === void 0 ? void 0 : props.layoutProps;

  if (theme) {
    return /*#__PURE__*/_jsxs(NativeBaseProvider, {
      theme: theme,
      children: [/*#__PURE__*/_jsx(React.Suspense, {
        fallback: /*#__PURE__*/_jsx(_Fragment, {}),
        children: /*#__PURE__*/_jsx(GlobalMessageBanner, {})
      }), layoutProps !== null && layoutProps !== void 0 && layoutProps.showMinimalHeader ? /*#__PURE__*/_jsx(React.Suspense, {
        fallback: /*#__PURE__*/_jsx(_Fragment, {}),
        children: /*#__PURE__*/_jsx(MinimalHeader, {})
      }) : /*#__PURE__*/_jsx(Header, {
        brand: "LH",
        links: links,
        showJoinWaitListHeader: layoutProps === null || layoutProps === void 0 ? void 0 : layoutProps.showJoinWaitListHeader,
        showJoinWaitListConfirmationHeader: layoutProps === null || layoutProps === void 0 ? void 0 : layoutProps.showJoinWaitListConfirmationHeader,
        showWaitListVisibilityHeader: layoutProps === null || layoutProps === void 0 ? void 0 : layoutProps.showWaitListVisibilityHeader,
        showConfirmReservationHeader: layoutProps === null || layoutProps === void 0 ? void 0 : layoutProps.showConfirmReservationHeader,
        showMobilePayHeader: layoutProps === null || layoutProps === void 0 ? void 0 : layoutProps.showMobilePayHeader,
        openCartSlider: opnSldr === "true" ? true : false,
        hideLinks: !!(layoutProps !== null && layoutProps !== void 0 && layoutProps.hideLinks),
        isDineInLinks: !!(layoutProps !== null && layoutProps !== void 0 && layoutProps.isDineInLinks),
        isDineInConfirmationPage: !!(layoutProps !== null && layoutProps !== void 0 && layoutProps.isDineInConfirmationPage),
        isDeliveryPage: !!(layoutProps !== null && layoutProps !== void 0 && layoutProps.isDeliveryPage)
      }), /*#__PURE__*/_jsx(React.Suspense, {
        fallback: /*#__PURE__*/_jsx(_Fragment, {}),
        children: /*#__PURE__*/_jsx(LoginPopup, {})
      }), /*#__PURE__*/_jsx(React.Suspense, {
        fallback: /*#__PURE__*/_jsx(_Fragment, {}),
        children: /*#__PURE__*/_jsx(SuccessDialog, {})
      }), /*#__PURE__*/_jsx(React.Suspense, {
        fallback: /*#__PURE__*/_jsx(_Fragment, {}),
        children: /*#__PURE__*/_jsx(ErrorDialog, {})
      }), /*#__PURE__*/_jsx(LayoutContainer, {
        hideGlobalBanner: layoutProps === null || layoutProps === void 0 ? void 0 : layoutProps.showMobilePayHeader,
        children: props.children
      })]
    });
  } else {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: "Loading Theme"
    });
  }
};

export default NativeBaseLayout;